import React, { useEffect } from 'react';
import EligibilityEnginePageView from '../views/EligibilityEnginePage/Index';
import {
  useEligibilityProducts,
  useEligibilityActions,
  useEligibilityTheme,
  useEligibilityRules,
  useHasUnsavedChanges,
} from '../hooks/useEligibilityEngine';

const EligibilityEnginePage = () => {
  const {
    productsLoading, productsError, products, selectedProduct,
  } = useEligibilityProducts();
  const {
    fetchProducts,
    fetchRules,
    onRevert,
    onPublish,
    onProductChange,
    onIfNullChange,
    upsertNote,
    onAddRule,
    onRemoveRule,
  } = useEligibilityActions();
  const { productType, selectedProductData, themeClass } = useEligibilityTheme();
  const { rules, isRulesLoading, rulesError } = useEligibilityRules();
  const hasUnsavedChanges = useHasUnsavedChanges();

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  // Fetch rules whenever the selected product changes
  useEffect(() => {
    if (selectedProduct) {
      fetchRules(selectedProduct);
    }
  }, [selectedProduct, fetchRules]);

  if (productsLoading) {
    return <div>Loading products...</div>;
  }

  if (productsError) {
    return <div>Error loading products. Please try again.</div>;
  }

  return (
    <EligibilityEnginePageView
      themeClass={themeClass}
      rules={rules}
      isRulesLoading={isRulesLoading}
      rulesError={rulesError}
      products={products}
      selectedProduct={selectedProduct}
      selectedProductData={selectedProductData}
      productType={productType}
      hasUnsavedChanges={hasUnsavedChanges}
      onRevert={onRevert}
      onPublish={onPublish}
      fetchRules={fetchRules}
      onProductChange={onProductChange}
      onIfNullChange={onIfNullChange}
      upsertNote={upsertNote}
      onAddRule={onAddRule}
      onRemoveRule={onRemoveRule}
    />
  );
};

export default EligibilityEnginePage;
